"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.PortalWrapper = void 0;
var React = require("react");
var ReactDOM = require("react-dom");
var modalClassName = "starryui-modal";
var srwClassName = "srw";
// This is a class for a reason.
var PortalWrapper = /** @class */ (function (_super) {
    __extends(PortalWrapper, _super);
    function PortalWrapper(props) {
        var _this = _super.call(this, props) || this;
        _this.element = document.createElement("div");
        _this.element.className = srwClassName + " " + modalClassName;
        _this.modalRoot = document.body;
        return _this;
    }
    PortalWrapper.prototype.componentDidMount = function () {
        // The portal element is inserted in the DOM tree after
        // the PortalWrapper's children are mounted, meaning that children
        // will be mounted on a detached DOM node. If a child
        // component requires to be attached to the DOM tree
        // immediately when mounted, for example to measure a
        // DOM node, or uses 'autoFocus' in a descendant, add
        // state to PortalWrapper and only render the children when PortalWrapper
        // is inserted in the DOM tree.
        //
        // NOTE: Adding state (i.e. not immediately rendering the children) breaks refs,
        // so make sure you make this optional.
        this.modalRoot.appendChild(this.element);
    };
    PortalWrapper.prototype.componentWillUnmount = function () {
        this.modalRoot.removeChild(this.element);
    };
    PortalWrapper.prototype.render = function () {
        return ReactDOM.createPortal(this.props.children, this.element);
    };
    return PortalWrapper;
}(React.Component));
exports.PortalWrapper = PortalWrapper;
